import { atom } from "jotai";

export const dateFiltersAtom = atom<any>({
  dataType: "Sum",
  dateType: "Last 7 Days",
});
